var _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 160,
    viewBox: "0 0 370 160",
    width: 370,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00909e"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 365,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365,
    cy: 35,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 35,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: 35,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 35,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 35,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 35,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 35,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 35,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 35,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 35,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 35,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 35,
    r: 5
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 365,
    cy: 65,
    fill: "#5864ff",
    r: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 65,
    fill: "#5864ff",
    r: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: 65,
    fill: "#5864ff",
    r: 5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 65,
    fill: "#5864ff",
    r: 5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 65,
    fill: "#5864ff",
    r: 5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 65,
    fill: "#5864ff",
    r: 5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 65,
    fill: "#fff",
    r: 5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 65,
    fill: "#fff",
    r: 5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 65,
    fill: "#fff",
    r: 5
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 65,
    fill: "#fff",
    r: 5
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 65,
    fill: "#fff",
    r: 5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 65,
    fill: "#fff",
    r: 5
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 65,
    fill: "#fff",
    r: 5
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 365,
    cy: 95,
    fill: "#5864ff",
    r: 5
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 95,
    fill: "#5864ff",
    r: 5
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: 95,
    fill: "#5864ff",
    r: 5
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 95,
    fill: "#5864ff",
    r: 5
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 95,
    fill: "#5864ff",
    r: 5
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 95,
    fill: "#5864ff",
    r: 5
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 95,
    fill: "#fff",
    r: 5
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 95,
    fill: "#fff",
    r: 5
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 95,
    fill: "#fff",
    r: 5
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 95,
    fill: "#fff",
    r: 5
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 95,
    fill: "#fff",
    r: 5
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 95,
    fill: "#fff",
    r: 5
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 95,
    fill: "#fff",
    r: 5
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 365,
    cy: 125,
    fill: "#5864ff",
    r: 5
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 125,
    fill: "#5864ff",
    r: 5
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: 125,
    fill: "#5864ff",
    r: 5
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 125,
    fill: "#5864ff",
    r: 5
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 125,
    fill: "#5864ff",
    r: 5
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 125,
    fill: "#5864ff",
    r: 5
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 125,
    fill: "#5864ff",
    r: 5
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 125,
    fill: "#fff",
    r: 5
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    fill: "#fff",
    r: 5
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 125,
    fill: "#fff",
    r: 5
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 125,
    fill: "#fff",
    r: 5
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 125,
    fill: "#fff",
    r: 5
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 125,
    fill: "#fff",
    r: 5
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 365,
    cy: 155,
    fill: "#5864ff",
    r: 5
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 155,
    fill: "#5864ff",
    r: 5
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: 155,
    fill: "#5864ff",
    r: 5
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 155,
    fill: "#5864ff",
    r: 5
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 155,
    fill: "#5864ff",
    r: 5
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 155,
    fill: "#5864ff",
    r: 5
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 155,
    fill: "#5864ff",
    r: 5
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 155,
    fill: "#5864ff",
    r: 5
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 155,
    fill: "#fff",
    r: 5
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 155,
    fill: "#fff",
    r: 5
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 155,
    fill: "#fff",
    r: 5
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 155,
    fill: "#fff",
    r: 5
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 155,
    fill: "#fff",
    r: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftDots);
export default __webpack_public_path__ + "static/media/left-dots.ca45c6f4094a09ff270ffc4c270939fa.svg";
export { ForwardRef as ReactComponent };